import { LoadingButton } from '@mui/lab';
import { Button } from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useHistory } from 'react-router-dom';
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from '../../../../configs/messages';
import { ROUTES_LIST } from '../../../../helpers/routesList';
import { sendFileData } from '../../../../helpers/sendFileData';
import showMessage from '../../../../helpers/showMessage';
import './programFileUpload.css';

export function ProgramFileUploadField({ sendRequest, epgProgramId }) {
    const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
        maxFiles: 1,
        accept: '.csv',
        multiple: false,
    });
    const [uploadingFiles, setUploadingFiles] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();

    const files = acceptedFiles.map((file) => (
        <li key={file.path}>
            {file.path} - {file.size} bytes
        </li>
    ));

    const handleFileUpload = async () => {
        if (!acceptedFiles || acceptedFiles.length === 0) {
            showMessage(ERROR_MESSAGES.FILE_NOT_FOUND, enqueueSnackbar);
            return;
        }

        // Validate CSV file type
        const file = acceptedFiles[0];
        if (!file.name.endsWith('.csv')) {
            showMessage('CSV файл сонгоно уу', enqueueSnackbar, 'error');
            return;
        }

        setUploadingFiles(true);

        try {
            const programId = await sendRequest();
            if (programId) {
                const response = await sendFileData(
                    acceptedFiles[0],
                    `program-file?parent-id=${programId}`,
                );
                console.log('Response res: ', response);
                if (response.data?.statusCode === 200) {
                    showMessage(SUCCESS_MESSAGES.ADDED_DATA, enqueueSnackbar);
                    history.push(ROUTES_LIST.programFileList);
                    setTimeout(() => {}, 1500);
                    window.location.reload();
                }
            }
        } catch (error) {
            console.error(error);
            const message = error.response?.data?.message
                ? error.response.data.message
                : error.message;
            showMessage(message, enqueueSnackbar, 'error');
            setUploadingFiles(false);
        }
    };

    return (
        <section>
            <div {...getRootProps({ className: 'dropzone' })}>
                <input {...getInputProps({ accept: '.csv' })} />
                <p style={{ padding: '40px' }}>
                    Drag 'n' drop a file here, or click to select a file
                </p>
            </div>
            <aside style={{ marginLeft: '50px' }}>
                <h4>Хуулагдах файл</h4>
                <ul>{files}</ul>
                {uploadingFiles ? (
                    <LoadingButton loading variant="outlined" color="success">
                        Submit
                    </LoadingButton>
                ) : (
                    // <CircularProgress disableShrink />
                    <Button
                        variant="outlined"
                        color="success"
                        onClick={handleFileUpload}
                        autoFocus
                    >
                        Хуулах
                    </Button>
                )}
            </aside>
        </section>
    );
}
